'use client';

// #region IMPORT
import AutoScroll from 'embla-carousel-auto-scroll';

// @mui
import { Box, Stack, Typography } from '@mui/material';

import { BRAND_COLOR } from 'src/theme/core';

import { Carousel, useCarousel } from 'src/components/carousel';
// #endregion
// components

// ----------------------------------------------------------------------

const BRANDS = [
  { name: 'amslink', ext: 'png' },
  { name: 'supermind', ext: 'png' },
  { name: 'peaworld', ext: 'png' },
  { name: 'nhantri', ext: 'png' },
  { name: 'newlife', ext: 'png' },
  { name: 'maihouse', ext: 'png' },
  { name: 'leadingstart', ext: 'png' },
  { name: 'vietmy', ext: 'jpg' },
  { name: 'senda', ext: 'jpg' },
  { name: 'hoaingo', ext: 'jpg' },
  { name: 'candy', ext: 'jpg' },
  { name: 'americancorner', ext: 'jpeg' },
];

const brands = BRANDS.map((brand, index) => ({
  id: index,
  name: brand.name,
  image: `/assets/landing/customer/${brand.name}.${brand.ext}`,
}));

export const CustomerElearning = () => {
  const carousel = useCarousel({ loop: true, slidesToShow: { md: 10, sm: 6, xs: 3 } }, [
    AutoScroll({ playOnInit: true, speed: 1 }),
  ]);

  return (
    <Stack spacing={4} py={{ xs: 4, sm: 6, md: 10 }}>
      <Typography textAlign="center" component="span">
        <Typography
          fontWeight="bold"
          sx={{
            mr: 0.5,
            backgroundImage: BRAND_COLOR,
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block',
          }}
        >
          1.000+ trung tâm và giáo viên khởi nghiệp
        </Typography>
        đã tự động hóa thành công quy trình quản lý và giảng dạy
      </Typography>
      <Carousel
        carousel={carousel}
        slotProps={{
          slide: {
            paddingLeft: 2,
            alignItems: 'center',
            display: 'flex',
          },
        }}
      >
        {brands.map((brand) => {
          const isAmslink = brand.name === 'amslink';

          return (
            <Box
              key={brand.id}
              alt={brand.name}
              component="img"
              src={brand.image}
              sx={{
                height: 80,
                width: isAmslink ? 110 : 80,
                objectFit: 'contain',

                ...(isAmslink
                  ? {
                      boxShadow: 'none',
                      borderRadius: 0,
                    }
                  : {
                      boxShadow:
                        '1px 1px 4px 0px rgba(145, 158, 171, 0.14), -1px 1px 2px 0px rgba(145, 158, 171, 0.16)',
                      borderRadius: 2,
                    }),
              }}
              m={1}
            />
          );
        })}
      </Carousel>
    </Stack>
  );
};
